import { createApp } from 'vue';
import RarToZipConverter from '@/Components/RarToZipConverter.vue';
import '@styles/app.css';

createApp(RarToZipConverter).mount('#rar-to-zip-converter');
